var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.isVisible)?_c('Transition',{attrs:{"appear":""}},[_c('figure',{class:( _obj = {}, _obj[_vm.$style.cropContainer] = _vm.isCroppedAndCentered, _obj ),style:({
                'max-width': _vm.cropWidth,
                'max-height': _vm.cropHeight,
            })},[_c('picture',{class:_vm.$style.image},[(_vm.hasWebp)?_c('source',{attrs:{"srcset":_vm.imageSlugPath + '.webp',"type":"image/webp"}}):_vm._e(),_c('img',_vm._b({style:({
                        height: _vm.height,
                        width: _vm.width,
                    }),attrs:{"src":_vm.imagePath,"alt":_vm.alt}},'img',_vm.$attrs,false))])])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }